// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Xk-z","red":"Yk-z","calloutlink":"Zk-z","headerTopBanner":"_k-z","bgcolorRed":"al-z","headerTopCallout":"bl-z","searchBanner":"cl-z","hideMobile":"dl-z"};